import React, { useGlobal } from 'reactn';
import ComputerIcon from '@material-ui/icons/Computer';
import ResetIcon from '@material-ui/icons/Undo';
import PrintIcon from '@material-ui/icons/Print';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import SaveIcon from '@material-ui/icons/Save';
import LoadIcon from '@material-ui/icons/CloudDownload';
import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';
import OverwriteIcon from '@material-ui/icons/SaveAlt';
import { useLogger } from '../logger';
import { useHistory } from "react-router-dom";
import { Roles } from '../models';
import CompanyIcon from '@material-ui/icons/Business';
import UserIcon from '@material-ui/icons/Person';
import AgencyIcon from '@material-ui/icons/HomeWork';
import ExitIcon from '@material-ui/icons/ExitToApp';
import { Divider, Fab, Grid, IconButton, List, ListItem, ListItemIcon, ListItemText, Paper, Tab, Tabs, Theme, Tooltip, Typography, useTheme, createStyles, makeStyles, SwipeableDrawer } from '@material-ui/core';
import { IGlobalState } from '../states/GlobalState';
import { Applicazioni } from '../types/types';
import { default as LogoutIcon, default as OutputIcon } from '@material-ui/icons/ExitToApp';
import { drawerMobileWidth } from '../types/constants';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
    //Drawer
    drawer: {
      width: drawerMobileWidth,
      flexShrink: 0,
    },
    drawerPaper: {
      width: drawerMobileWidth,
    },
    drawerHeader: {
      display: 'flex',
      alignItems: 'center',
      padding: '0 8px',
      ...theme.mixins.toolbar,
      justifyContent: 'flex-end',
      minHeight: '60px!important'
    },
    nav: {
      flex: 1,
      '&:hover': {
          overflow: 'auto'
      }
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(1),
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: -drawerMobileWidth,
    },
    contentShift: {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    },
    buttonIcon: {
      margin: "1rem",
      cursor: "pointer"
    }
  }),
);

export type DrawerProps = {
    handleClickReset: any;
    handleExit: any;    
    print: any;
    handleClickSovrascrivi: any;
    handleClickSalva: any;
    handleClickCarica: any;
    handleClickShowVideo: any;
    showOverwrite: boolean
}

export default function DrawerMobile(props: DrawerProps) {
    const theme = useTheme();
    const classes = useStyles();
    const [identity,] = useGlobal<IGlobalState, 'identity'>('identity');
    const [application, setApplication] = useGlobal<IGlobalState, 'application'>('application');
    // const [drawerMobileIndex, setDrawerMobileIndex] = useGlobal<IGlobalState, 'drawerMobileIndex'>('drawerMobileIndex');
    const [auth] = useGlobal<IGlobalState, 'auth'>('auth');
    const history = useHistory();
    const logger = useLogger({key: 'identity'});
    const [drawerMobileIsOpen, setDrawerMobileIsOpen] = useGlobal<IGlobalState, 'drawerMobileIsOpen'>('drawerMobileIsOpen');

    function handleDrawerMobileClose() {
      setDrawerMobileIsOpen(false);
    }
          
    return (
        <>
        <SwipeableDrawer
            id='drawerMobile'
            className={classes.drawer}
            variant="temporary"
            anchor="right"
            open={drawerMobileIsOpen}
            classes={{paper: classes.drawerPaper}}
            onOpen={() => setDrawerMobileIsOpen(true)}
            onClose={() => setDrawerMobileIsOpen(false)}
            style={{ overflowX: 'hidden'}}
        >
            <div className={classes.drawerHeader}>
                <IconButton onClick={handleDrawerMobileClose}>
                    {theme.direction === 'ltr' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                </IconButton>
            </div>
            <Divider />
            <List>
                <ListItem >
                  <ListItemIcon>
                      <PrintIcon className={classes.buttonIcon} onClick={props.print} titleAccess='Stampa'/> 
                  </ListItemIcon>
                </ListItem>
                {application <= Applicazioni.Budget4u ?
                <>
                <ListItem >
                  <ListItemIcon>
                      <ResetIcon className={classes.buttonIcon} onClick={props.handleClickReset} titleAccess='Reset'/> 
                  </ListItemIcon>
                </ListItem>
                <ListItem >
                  <ListItemIcon>
                      <SaveIcon className={classes.buttonIcon} onClick={props.handleClickSalva} titleAccess='Salva'/>
                  </ListItemIcon>
                </ListItem>
                <ListItem >
                  <ListItemIcon>
                    <OverwriteIcon className={classes.buttonIcon} style={{display: props.showOverwrite ? "": "none"}} onClick={props.handleClickSovrascrivi} titleAccess='Sovrascrivi elaborazione'></OverwriteIcon>
                  </ListItemIcon>
                </ListItem>
                <ListItem >
                  <ListItemIcon>
                    <LoadIcon className={classes.buttonIcon} onClick={props.handleClickCarica} titleAccess='Carica elaborazione'></LoadIcon>
                  </ListItemIcon>
                </ListItem>
                <ListItem >
                  <ListItemIcon>
                    <VideoLibraryIcon className={classes.buttonIcon} onClick={props.handleClickShowVideo} titleAccess='Help'></VideoLibraryIcon>
                  </ListItemIcon>
                </ListItem>
                </>
                : null}
                <ListItem >
                  <ListItemIcon>
                      <ExitIcon className={classes.buttonIcon} onClick={props.handleExit} titleAccess='Esci'/> 
                  </ListItemIcon>
                </ListItem>
            </List>
        </SwipeableDrawer>
        </>
    );
}